import { Box, Tag, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { formatNumber } from "../../../store/helpers";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
} from "../../../store/renderConfig";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";

export const getAgentTicketsPerServiceRows = (branch, service) => {
  const totalServiceData = Number(service.totalServiceData) || 0;
  return (service.agentsData || [])
    .filter((agent) => Number(agent?.total))
    .map((agent) => ({
      ...agent,
      branchName: branch.branchName || "",
      serviceName: service.serviceName || agent.serviceName || "",
      totalPct: totalServiceData ? ((Number(agent.total) || 0) / totalServiceData) * 100 : 0,
    }));
};

export const renderAgentTicketsPerServiceCell = (agentData, columnId) => {
  if (columnId === "serviceName") return agentData.serviceName;
  if (columnId === "agentName") return agentData.agentName;
  if (columnId === "total") {
    return <Text color="var(--green)">{formatNumber(agentData.total)}</Text>;
  }
  if (columnId === "percentage") return `${Number(agentData.totalPct || 0).toFixed(2)}%`;
  if (columnId === "average") return formatNumber(agentData.average);
  if (columnId === "min") return formatNumber(agentData.min);
  if (columnId === "max") return formatNumber(agentData.max);
  if (columnId === "completed") {
    return (
      <Text color="var(--green)">
        {formatNumber(agentData.numCompleted)}
        <Box className="agentTicketMutedCell">
          ({Number(agentData.pctCompleted || 0).toFixed(2)}%)
        </Box>
      </Text>
    );
  }
  if (columnId === "noShow") {
    return (
      <Text color="var(--red)">
        {formatNumber(agentData.numNoShow)}
        <Box className="agentTicketMutedCell">
          ({Number(agentData.pctNoShow || 0).toFixed(2)}%)
        </Box>
      </Text>
    );
  }
  if (columnId === "unattended") {
    return (
      <Text color="var(--red)">
        {formatNumber(agentData.numUnattended)}
        <Box className="agentTicketMutedCell">
          ({Number(agentData.pctUnattended || 0).toFixed(2)}%)
        </Box>
      </Text>
    );
  }
  return null;
};

const AgentServicesTable = ({
  serviceData,
  branchName,
  reportTitle,
  reportDescription,
  showReportTitle,
  branchTitle,
  numServices,
  showBranchTitle,
  reportIndex,
  branchIndex,
  index,
}) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig({ ...renderConfig, charts: { enabled: false } }, {
    columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });
  const { serviceName, totalServiceData } = serviceData;
  const rows = getAgentTicketsPerServiceRows({ branchName }, serviceData);
  const title = `${reportIndex || ""}.${branchIndex + 1}.${index + 1}. ${serviceName}`;

  return (
    <Box className="reportTableContainer agentTicketsPerServiceBlock">
      {showReportTitle && (
        <>
          <h1>{reportTitle}</h1>
          <p>{reportDescription}</p>
        </>
      )}
      {showBranchTitle && (
        <>
          <h2>{branchTitle}</h2>
          <Text>{numServices} services.</Text>
        </>
      )}
      <h3>{title}</h3>
      {!totalServiceData ? <Text fontSize="sm">No data available for this report</Text> : null}
      <Tag.Root>
        <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
      </Tag.Root>

      {totalServiceData ? (
        <ConfiguredReportTable
          columns={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={rows}
          renderConfig={config}
          renderCell={renderAgentTicketsPerServiceCell}
        />
      ) : null}
    </Box>
  );
};

export default AgentServicesTable;
